import { createSlice, type PayloadAction } from '@reduxjs/toolkit'
import type { AuthSlice, User } from '../types'

const initialState: AuthSlice = {
  accessToken: null,
}

const slice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    authUser(state, { payload }: PayloadAction<{ accessToken: string; user: User }>) {
      state.accessToken = payload.accessToken
      state.user = payload.user
    },
    signOut(state) {
      state.accessToken = null
      delete state.user
    },
    patchUser(state, { payload }: PayloadAction<Partial<User>>) {
      if (state.user) {
        state.user = { ...state.user, ...payload }
      }
    },
  },
})

export const { authUser, signOut, patchUser } = slice.actions
export default slice.reducer
